<template>
  <v-layout column class="flex-none top-sticky">
    <v-layout
      justify-space-between
      align-center
      class="wrapper"
      :class="{ 'xs-wrapper': $vuetify.breakpoint.xsOnly, 'in-modal': inModal, 'pt-3': $vuetify.breakpoint.mdAndUp }">
      <!-- BACK -->
      <v-flex xs3 sm4 :style="`top: ${dripOffset}px`">
        <v-layout
          v-if="$route.name !== routeNames.main.name"
          @click="$router.go(-1)"
          align-center
          id="toolbar-back"
          class="clickable toolbar-text ml-3"
          :class="{ 'ml-8': $vuetify.breakpoint.mdAndUp }">
          <v-icon
            color="primary"
            class="mr-1"
            :class="{ 'mr-2' : $vuetify.breakpoint.smAndUp }"
            :size="$vuetify.breakpoint.xsOnly ? 23 : 30">
            mdi-arrow-left
          </v-icon>
          <span v-if="$vuetify.breakpoint.smAndUp" :class="{ 'max-width-100': $vuetify.breakpoint.smAndDown }">
            {{ backText }}
          </span>
        </v-layout>
      </v-flex>
      <!-- LOGO -->
      <v-flex xs6 sm4 :style="`top: ${dripOffset}px`">
        <v-layout justify-center>
          <div @click="clickLogo()" :class="{ 'clickable': $route.name !== routeNames.main.name }">
            <img :src="require('@/assets/Aqua.png')" class="flex-none toolbar-logo" />
          </div>
        </v-layout>
      </v-flex>
      <!-- (SUMMARY &) LOGOUT -->
      <v-flex xs3 sm4 :style="`top: ${dripOffset}px`">
        <v-layout justify-end align-center>
          <order-summary v-if="displayOrderSummary" menu />
          <v-divider v-if="displayOrderSummary" vertical class="mx-3 primary" :class="{ 'mx-5': $vuetify.breakpoint.mdAndUp }"/>
          <span
            v-if="$vuetify.breakpoint.mdAndUp"
            @click="logoutDialog = true"
            class="toolbar-text clickable mr-4"
            :class="{ 'mr-8': $vuetify.breakpoint.mdAndUp }">
            {{ $t('actions.sign_out') }}
          </span>
          <v-icon v-else
            color="primary"
            @click="logoutDialog = true"
            class="mr-4 clickable"
            :size="$vuetify.breakpoint.xsOnly ? 23 : 30">
            logout
          </v-icon>
        </v-layout>
      </v-flex>
      <v-dialog v-model="logoutDialog" persistent width="300">
      <v-card>
        <v-card-title>
          {{$t('actions.sign_out')}}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="logoutDialog = false">{{ $t('actions.cancel') }}</v-btn>
          <v-btn color="primary darken-1" text @click="$store.dispatch('auth/signOut')">{{ $t('actions.accept') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-layout>
    <drip :primaryColor="false" class="drip-image" ref="drip" />
  </v-layout>
</template>

<script>
import routeNames from '@/router/routes'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      routeNames,
      dripOffset: 0,
      logoutDialog: false
    }
  },
  computed: {
    ...mapState(['state']),
    inModal () {
      return this.state.inModal
    },
    route () {
      return routeNames[this.$route.name]
    },
    backText () {
      return this.$vuetify.breakpoint.xsOnly && this.route.xsBackString
        ? this.route.xsBackString : this.route.backString
    },
    displayOrderSummary () {
      return this.route.orderSummary && this.$vuetify.breakpoint.smAndUp
    }
  },
  methods: {
    clickLogo () {
      if (this.route.name !== routeNames.main.name) {
        this.$router.push({ name: routeNames.main.name })
      }
    },
    getDripOffset () {
      this.dripOffset = this.$refs.drip ? this.$refs.drip.height / 15 : 0
    }
  },
  updated () {
    this.getDripOffset()
  },
  created () {
    window.addEventListener('resize', this.getDripOffset)
  },
  components: {
    OrderSummary: () => import('@/components/view-components/OrderSummary.vue'),
    Drip: () => import('@/components/app-components/Drip.vue')
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getDripOffset)
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  background-color: white;
  height: 80px;
  position: relative;
}
.wrapper > div {
  position: relative;
}
// .in-modal {
//   background-color: red;
//   & .logo {
//     background-color: red;
//   }
// }
.xs-wrapper {
  & .toolbar-text {
    font-size: 13px;
  }
}
.toolbar-text {
  color: var(--v-primary-base);
  font-weight: 1000;
  font-size: 20px;
  text-transform: uppercase;
}
.toolbar-logo {
  max-width: 150px;
  max-height: 60px;
  @media (max-width: 690px) {
    max-width: 100px;
  }
}
.drip-image {
  max-width: 100%;
  max-height: 100px;
}
</style>
